<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-lg-3 vcenter">
      <h3>Management Dashboard</h3>
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />
  <div row> <b>Timesheet Reports:</b>
    <div class="col-xs-12 report-row">
      <aims-common-button aria-label="CLIN Hours" routerLink="/reporting/CLINHoursFromTimeSheet/trdp/{{defaultCLIN()}}">
        CLIN Hours
      </aims-common-button>

      <aims-common-button aria-label="CLIN Hours Summary"
        routerLink="/reporting/CLINHoursFromTimeSheetSummary/trdp/{{defaultCLIN()}}">
        CLIN Hours Summary
      </aims-common-button>

      <aims-common-button aria-label="CLIN Hours Detail"
        routerLink="/reporting/CLINHoursFromTimeSheetDetails/trdp/{{defaultCLIN()}}">
        CLIN Hours Detail
      </aims-common-button>
    </div>

    <div class="col-xs-12 report-row">
      <aims-common-button aria-label="Old CLIN Hours" routerLink="/reporting/Old_CLINHoursFromTimeSheet/trdp/{{defaultCLIN()}}">
        Old CLIN Hours
      </aims-common-button>

       <aims-common-button aria-label="Old CLIN Hours Summary"
        routerLink="/reporting/Old_CLINHoursFromTimeSheetSummary/trdp/{{defaultCLIN()}}">
        Old CLIN Hours Summary
      </aims-common-button>

      <aims-common-button aria-label="Old CLIN Hours Detail"
        routerLink="/reporting/Old_CLINHoursFromTimeSheetDetails/trdp/{{defaultCLIN()}}">
        Old CLIN Hours Detail
      </aims-common-button>
    </div>

  </div>

  <div row class="report-row"> <b>COPA Reports:</b>
    <div class="col-xs-12 report-row">
      <aims-common-button aria-label="COPA Summary"
        routerLink="/reporting/COPA_DSW_Summary_Report/trdp">
        COPA Summary
      </aims-common-button>

      <aims-common-button aria-label="COPA Detail"
        routerLink="/reporting/COPA_DSW_Report/trdp">
        COPA Detail
      </aims-common-button>
    </div>
  </div>
  <div row class="report-row"> <b>F004 Reports:</b>
    <div class="col-xs-12 report-row">
      <aims-common-button aria-label="F004 Totals"
        routerLink="/reporting/F004TotalsByContractYearAndCLIN/trdp">
        F004 Totals
      </aims-common-button>
      <aims-common-button aria-label="F004 Detail"
        routerLink="/reporting/F004DetailsByContractYearAndCLIN/trdp">
        F004 Detail
      </aims-common-button>
    </div>
  </div>
  <div row class="report-row"> <b>Other Reports:</b>
    <div class="col-xs-12 report-row">
      <aims-common-button aria-label="Authority Matrix"
        routerLink="/reporting/Purchase_Authority/trdp">
        Authority Matrix
      </aims-common-button>
    </div>
    <div class="col-xs-12 report-row">
      <aims-common-button aria-label="SBA Report"
        routerLink="/reporting/SBA_Report/trdp">
        SBA Report
      </aims-common-button>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
